module.exports = __webpack_public_path__ + "img/access_control.97812287.jpg";